




























































import Vue from "vue";
import store, { InvoiceFlowStore } from "../services/InvoiceFlowStore";
import IncomingInvoiceRemark from "../models/IncomingInvoiceRemark";
import permStore, { PermissionStore } from "../../../services/permissions";
import eventBus from "@/services/eventBus";
import User, { userDefaultProps, userTechProps } from "@/modules/user/models/User";

interface Data {
  store: InvoiceFlowStore;
  permStore: PermissionStore;
  invoiceId: number;
  remark: IncomingInvoiceRemark;
  selectedUser: User | undefined;
  selectedUsers: User[];
}

interface Methods {
  createRemark(): void;
  onChengeFlowRemarkUsers(user: User): void;
  confirmUserDelete(user: User): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  props: {
    invId: { type: Number },
  },

  data: () => ({
    store,
    permStore,
    invoiceId: 1,
    remark: new IncomingInvoiceRemark(),
    selectedUser: { ...userDefaultProps },
    selectedUsers: [],
  }),

  async beforeMount() {
    this.invoiceId = Number(this.$route.params.invoiceId);
  },

  methods: {
    async createRemark() {
      if (this.remark.remark.trim().length <= 1) return;

      const invoiceID = Number(this.$route.params.invoiceId);
      if (Number.isNaN(invoiceID)) return;

      this.remark.invId = invoiceID;
      this.remark.statusId = Number(this.store.step);
      this.remark.relatedUsers = this.selectedUsers;

      await this.store.createRemark(this.remark).then(async () => {
        eventBus.$emit("flow-remark:created");
        this.remark = new IncomingInvoiceRemark({
          invId: invoiceID,
          statusId: this.store.step,
          relatedUsers: this.selectedUsers,
        });
        await this.store.loadRemarks(this.invoiceId);
      });

      await this.store.loadRemarks(invoiceID);
    },

    onChengeFlowRemarkUsers(user) {
      this.selectedUsers.push(user);
      this.selectedUser = { ...userDefaultProps };
    },

    confirmUserDelete(user) {
      const index = this.selectedUsers.indexOf(user);
      if (index > -1) this.selectedUsers.splice(index, 1);
    },
  },

  computed: {
    isInvId() {
      return Number.isNaN(Number(this.$route.params.invoiceId));
    },

    isPageDisabled() {
      switch (this.store.step) {
        default:
        case 2:
          return !this.permStore.hasRecording() || !this.store.isEditingEnabled;
        case 3:
          return !this.permStore.hasFinancialRecording() || !this.store.isEditingEnabled;
        case 4:
          return !this.permStore.hasStockRelationRecording() || !this.store.isEditingEnabled;
        case 5:
          return !this.permStore.hasControlling() || !this.permStore.hasAccepting() || !this.store.isEditingEnabled;
        case 6:
          return !this.permStore.hasAccounting(); // || !this.store.isEditingEnabled;
      }
    },

    selectableUsers() {
      return [
        ...this.store.flowUsers.fullfilmentApproval,
        ...this.store.flowUsers.fullfilmentChecking,
        ...this.store.flowUsers.invoiceApproval,
        ...this.store.flowUsers.invoiceChecking,
      ];
    },
  },
});
